import { Link } from 'react-router-dom';

export default function JoinTeam() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-[#2B2B2B] mb-6">
          Build Your Career with Deer Point
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-10">
          We are always looking for talented professionals who share our commitment to quality and safety. Whether you are an experienced project manager, superintendent, or skilled tradesperson, we want to hear from you.
        </p>
        <Link
          to="/careers"
          className="inline-block bg-[#C5A55A] text-[#2B2B2B] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#B39550] transition-colors whitespace-nowrap cursor-pointer"
        >
          View Open Positions
        </Link>
      </div>
    </section>
  );
}